import { makeRequest } from 'utils/requestLogger';

export default (id, roundtable_id) => {
  return makeRequest('get', `/api/recaps/${id}/roundtable/${roundtable_id}/comments`);
};



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/comment/getRecapComments.js